import moment from 'moment';

const handleDateChange = function(date) {
  const { time } = this.state;
  let scheduleDate = null;
  let timeValue = null, timeText = null;
  if (date) {
    const sendYear = date.format('YYYY'); // moment object
    const sendMonth = date.format('MM'); // moment object
    const sendDay = date.format('DD'); // moment object
    scheduleDate = sendYear + '-' + sendMonth + '-' + sendDay;

    const currentDate = new Date().getFullYear() + '-'
      + ('0' + (new Date().getMonth() + 1)).slice(-2) + '-'
      + new Date().getDate();

    if (scheduleDate === currentDate && (!time.text && !time.value)) {
      timeValue = moment(new Date())
      .add(
        20 - ( +moment().format('mm') % 5 ),
        'minutes'
      );
      timeText = `${timeValue.format('HH:mm')}:00`;
    } else {
      timeValue = moment('00:00:00', 'HH:mm:ss');
      timeText = '00:00:00';
    }

    // if no data for time
    if (!time.text && !time.value) {
      this.setState({
        time: {
          value: timeValue,
          text: timeText
        }
      });
    }
  } else {
    this.setState({
      time: {
        value: null,
        text: null
      },
      message: ''
    });
  }
  this.setState({
    day: {
      value: date,
      text: scheduleDate
    },
    message: ''
  });
};

export { handleDateChange };
